import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class RecruitmentCustomFieldItemOptionModel
  extends Model
  implements IModel<RecruitmentCustomFieldItemOptionModel> {
  public recruitmentCustomFieldId: string = "";
  public label: string = "";
  public legend: string = "";
  public order: number = 0;
  public isUpdate: boolean = false;

  static create(input: any): RecruitmentCustomFieldItemOptionModel {
    return ObjectMapper.deserialize<RecruitmentCustomFieldItemOptionModel>(
      RecruitmentCustomFieldItemOptionModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
